import { z } from 'zod';

import { OrganizationIdParamsSchema } from '../organizations/get-organization.schemas.js';

export { OrganizationIdParamsSchema };

export const OrganizationNetworkMembershipPlaceSchema = z.object({
  placeId: z.uuid(),
  placeName: z.string(),
  placeSlug: z.string(),
});

export type OrganizationNetworkMembershipPlace = z.infer<
  typeof OrganizationNetworkMembershipPlaceSchema
>;

export const OrganizationNetworkMembershipItemSchema = z.object({
  membershipId: z.uuid(),
  networkId: z.uuid(),
  networkName: z.string(),
  networkSlug: z.string(),
  networkActive: z.boolean(),
  agreementType: z.enum(['exclusive', 'preferred', 'partial']),
  status: z.enum(['active', 'suspended', 'terminated']),
  places: z.array(OrganizationNetworkMembershipPlaceSchema),
  validFrom: z.string(),
  validUntil: z.string().nullable(),
});

export type OrganizationNetworkMembershipItem = z.infer<
  typeof OrganizationNetworkMembershipItemSchema
>;

export const ListOrganizationNetworksResponseSchema = z.object({
  items: z.array(OrganizationNetworkMembershipItemSchema),
});

export type ListOrganizationNetworksResponse = z.infer<
  typeof ListOrganizationNetworksResponseSchema
>;
